import { Box, SxProps, Theme } from '@mui/material';
import React, { ReactNode } from 'react';

interface TabPanelProps {
    children?: ReactNode;
    value: string | number;
    index: string | number;
    disablePadding?: boolean;
    sx?: SxProps<Theme>;
    className?: string;
}

export default function TabPanel({
    children,
    value,
    index,
    disablePadding = false,
    sx,
    className
}: TabPanelProps) {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            className={className}
        >
            {value === index && (
                <Box sx={
                    typeof sx === 'function'
                        ? (theme) => ({ p: disablePadding ? 0 : 2, ...sx(theme) })
                        : [{ p: disablePadding ? 0 : 2 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]
                }>
                    {children}
                </Box>
            )}
        </Box>
    );
}
